import { Tooltip, LegacyDataTableHeaderColumn, LegacyDataTableRow, LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import type { ProjectResource, ProjectDeploymentFrequencyDeployment } from "@octopusdeploy/octopus-server-client";
import { TenantedDeploymentMode } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import type { ReactNode } from "react";
import { TrendTable } from "~/areas/insights/components/Reports/TrendTables/TrendTable/TrendTable";
import { formatDurationInWords } from "~/areas/insights/dataTransformation/stringHelpers";
import InternalLink from "~/components/Navigation/InternalLink";
import DateFormatter from "~/utils/DateFormatter";
interface Props {
    title: string;
    note: ReactNode;
    data: ProjectDeploymentFrequencyDeployment[];
    hideTimeSince?: boolean;
    project: ProjectResource;
}
export function ProjectDeploymentFrequencyTrendTable({ title, note, data, hideTimeSince, project }: Props) {
    const isTenanted = project.TenantedDeploymentMode != TenantedDeploymentMode.Untenanted;
    return (<TrendTable title={title} isEmpty={data.length === 0} note={note} headerContent={<LegacyDataTableRow>
                    {isTenanted && <LegacyDataTableHeaderColumn>Tenant</LegacyDataTableHeaderColumn>}
                    <LegacyDataTableHeaderColumn>Release</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>Completed</LegacyDataTableHeaderColumn>
                    {!hideTimeSince && <LegacyDataTableHeaderColumn>Time since previous successful deployment</LegacyDataTableHeaderColumn>}
                </LegacyDataTableRow>} bodyContent={<>
                    {data.map((r) => (<LegacyDataTableRow key={r.Id}>
                            {isTenanted && <LegacyDataTableRowColumn>{r.TenantName}</LegacyDataTableRowColumn>}
                            <LegacyDataTableRowColumn>
                                <InternalLink to={links.releasePage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug, releaseVersion: r.ReleaseVersion })}>{r.ReleaseVersion}</InternalLink>
                            </LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>
                                <Tooltip content={DateFormatter.dateToShortFormat(r.CompletedTime) || undefined}>
                                    <InternalLink to={links.deploymentPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug, releaseVersion: r.ReleaseVersion, deploymentId: r.Id })}>
                                        {DateFormatter.momentAgo(r.CompletedTime)}
                                    </InternalLink>
                                </Tooltip>
                            </LegacyDataTableRowColumn>
                            {!hideTimeSince && <LegacyDataTableRowColumn>{formatDurationInWords(r.TimeSincePreviouslySuccessfulDeployment)}</LegacyDataTableRowColumn>}
                        </LegacyDataTableRow>))}
                </>}/>);
}
